import type { ReactElement } from "react";
import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import useIndicatorParts from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/useIndicatorParts.ts";
import useIndicatorLabelAndUnit from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/useIndicatorLabelAndUnit.ts";

interface Properties {
  indicatorKey: IndicatorKey;
  summary: PeriodSummary;
}

export default function RecapTableCell(props: Properties): ReactElement {
  const { bigPart, smallPart } = useIndicatorParts(
    props.summary,
    props.indicatorKey,
  );
  const { unit } = useIndicatorLabelAndUnit(props.indicatorKey);
  return (
    <td className="recap-value-cell">
      {bigPart ?? "--"}
      {smallPart ?? ""}
      {bigPart !== undefined && unit !== undefined && ` ${unit}`}
    </td>
  );
}
